import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface NpsSurveyState {
  /** Сколько раз заходили на экран каждого опроса. Ключ — слаг фичи. */
  visits: Record<string, number>
  countVisit: (slug: string) => void
  /** Опрос, открытый вручную по кнопке. */
  manualSlug: string | null
  openSurvey: (slug: string) => void
  closeSurvey: () => void
  /** Слаги, уже показанные в этой сессии: второй раз за сессию не всплываем. */
  askedInSession: string[]
  markAsked: (slug: string) => void
}

/**
 * Состояние показа опросов.
 *
 * Счётчик заходов переживает перезапуск (иначе «второй заход» не наступит
 * никогда), а список показанного за сессию — нет: со следующего запуска
 * приложение вправе спросить снова, если бэк всё ещё отдаёт фичу.
 */
export const useNpsSurveyStore = create<NpsSurveyState>()(
  persist(
    set => ({
      visits: {},
      countVisit: slug =>
        set(state => ({
          visits: { ...state.visits, [slug]: (state.visits[slug] ?? 0) + 1 },
        })),

      manualSlug: null,
      openSurvey: slug => set({ manualSlug: slug }),
      closeSurvey: () => set({ manualSlug: null }),

      askedInSession: [],
      markAsked: slug =>
        set(state =>
          state.askedInSession.includes(slug)
            ? state
            : { askedInSession: [...state.askedInSession, slug] }
        ),
    }),
    {
      name: 'pauline:nps-survey',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: state => ({ visits: state.visits }),
    }
  )
)
